// extracted by mini-css-extract-plugin
export default {"searchBar":"iGKU1bsn331D84mR-w4MT","searchBlock":"_348aH-aA77-iKZ3VdP22N4"};